import CalendarIcon from "@mui/icons-material/CalendarToday"
import { PropertyAssigneeCreate } from "./property_assignees"

const propertyAssigneesResource = {
  icon: CalendarIcon,
  create: PropertyAssigneeCreate,
}

export default propertyAssigneesResource
